import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { uerActKC2SmrPriceItemsGql } from '../../workOrderQueries';

const requestId = 'uerActKC2SmrPriceItems';

export const useUerActKC2SmrPriceItems = (actKC2Id?: number) => {
    const [uerActKC2SmrPriceItemsReset] = useResetStoreData({ requestId });

    const variables = useMemo(() => ({ actKC2Id }), [actKC2Id]);

    const [uerActKC2SmrPriceItemsData, uerActKC2SmrPriceItemsStatus] = useRequest({
        requestId,
        query: uerActKC2SmrPriceItemsGql,
        variables,
        withEffect: !!actKC2Id,
    });

    useEffect(() => {
        uerActKC2SmrPriceItemsReset(undefined);
    }, [uerActKC2SmrPriceItemsReset]);

    const items = useMemo(
        () => uerActKC2SmrPriceItemsData?.uerActKC2SmrPriceItems?.items || [],
        [uerActKC2SmrPriceItemsData?.uerActKC2SmrPriceItems?.items],
    );

    return {
        items,
        status: uerActKC2SmrPriceItemsStatus,
    };
};
